import { useCallback, useEffect, useState } from 'react'

/** Хранит только ввод, не разрешения, цены или результат расчёта. */
export function useScopedInputDraft<T>(scope: string | null, empty: T) {
  const [saved, setSaved] = useState<{ scope: string; value: T } | null>(null)
  useEffect(() => {
    setSaved(previous => previous?.scope === scope ? previous : null)
  }, [scope])
  const value = scope !== null && saved?.scope === scope ? saved.value : empty
  const setValue = useCallback((next: T) => {
    if (scope !== null) setSaved({ scope, value: next })
  }, [scope])
  return [value, setValue] as const
}
